// Package imports
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import InputAdornment from "@mui/material/InputAdornment";
import "../Installation/InstallationLayout.css";
import { fetchSiteConfig } from "../../Store/Slices/DefsSlice";

import LockIcon from "@mui/icons-material/Lock";
import Confirmation from "../../Components/Modal/Confirmation";
import LoginHeader from "../../Components/UI/LoginHeader";
import LoginFooter from "../../Components/UI/LoginFooter";

// Custom imports
import { validatePasscode } from "./Services";
import { validator } from "../../Js/Validator";

// Component
const NewUserPasscodeValidate = () => {    
  // Hooks
  const passcodeText = useRef();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // State
  const [passcode, setPasscode] = useState("");
  const [validate, setValidate] = useState(false);
  const [passcodeError, setPasscodeError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  // Redux state
  const siteConfig = useSelector((state) => state.defs.siteConfig);

  // On blur get school name to display on top
  const getDefsFromAlias = () => {
    if (!passcode.includes("@")) {
      setPasscodeError("Incorrect passcode");
      setValidate(false);
      return false;
    }

    let alias = passcode.split("@");
    if (alias[alias.length - 1].trim().length == 0) {
      setPasscodeError("Alias is missing!");
      setValidate(false);
      return false;
    }

    dispatch(
      fetchSiteConfig({
        keyid: "site_config",
        keydata: {
          customer: {
            licenceAlias: alias[alias.length - 1].toUpperCase().trim(),
          },
        },
      })
    );
  };

  // Validate passcode on blur
  const passcodeBlurValidate = () => {
    let validate = validator({ required: true, value: passcode });
    if (!validate["validate"]) {
      setPasscodeError(validate["message"]);
      setValidate(false);
    } else {
      setPasscodeError(null);
      setValidate(true);
      getDefsFromAlias();
    }
  };

  // Validate credentials on login click & redirect to respective dashboard
  const validateCredentials = async () => {
    passcodeText.current.blur();
    if (validate) {
      let response = await validatePasscode(passcode.toUpperCase());
      console.log("@@##",response);
      if (response.status == 401) {
        setModalVisible(true);
      } else {
        resetState();
        if(response.data[0]["username"]){
          navigation(
            `/SetCredentials/${response.data[0]["uid"]}/${response.data[0]["username"]}`
          );
        }
        else{
          navigation(
            `/SetCredentials/${response.data[0]["uid"]}`
          );
        }
      }
    }
  };

  // Reset all states on successful login
  const resetState = () => {
    setPasscode("");
    setPasscodeError(null);
    setValidate(true);
  };

  // JSX template
  return (
    <Grid
      container
      spacing={1}
      className="full-height"
      sx={{ alignItems: "center" }}
    >
      <Grid item sm={12} md={6}>
        <Box
          sx={{
            bgcolor: "#DB8829",
            color: "primary.contrastText",
            display: { xs: "none", sm: "none", md: "block" },
          }}          
        >
          <img
            src={require('../../assets/VocabLogin_White.png')}
            width="100%  "
            alt="Vocablab"
          ></img>          
        </Box>
      </Grid>
      <Grid item sm={12} md={6}>
        <Box sx={{ p: 1, textAlign: "center" }}>
          <LoginHeader
            primaryText={
              !siteConfig || !siteConfig.schoolName
                ? "Your Institute"
                : siteConfig.schoolName
            }
            secondaryText="Enter your Login Credentials"
          ></LoginHeader>
          <Box>
            {/* {validateErrorMessage != null && (
              <Box sx={{ pt: 5, px: 10, textAlign: "center" }}>
                <Alert variant="filled" severity="error">
                  {validateErrorMessage}
                </Alert>
              </Box>
            )} */}
            <Box sx={{ pt: 5, px: 10, textAlign: "left" }}>
              <TextField
                ref={passcodeText}
                id="outlined-basic"
                placeholder="Passcode"
                variant="outlined"
                fullWidth
                type="text"
                onInput={(event) => {
                  setPasscode(event.target.value);
                }}
                value={passcode}
                onBlur={() => {
                  passcodeBlurValidate("FROM BLUR");
                }}
                InputProps={{
                  inputProps: { style: { padding: 10 } },
                  style: { borderRadius: 30 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#DB8829" }} />
                    </InputAdornment>
                  ),
                  sx: {fontSize: '0.9rem', color:'#DB8829',fontWeight: '500','@media (min-width: 1636px)': {
                    fontSize: '1.4rem'
                  }}
                }}
                helperText={passcodeError}
                error={passcodeError != null}
                onKeyDown={(event) => {
                  if (event.keyCode === 13) {
                    validateCredentials();
                  }
                }}
              />
            </Box>
            <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
              <Button
                variant="contained"
                fullWidth
                onClick={validateCredentials}
                sx={{background: '#DB8829', borderRadius: 20, fontWeight: "600",'@media (min-width: 1636px)': {
                  fontSize: '1.2rem'
                } }}
              >
                {" "}
                Validate{" "}
              </Button>
            </Box>
            <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => {
                  navigation(-1);
                }}
                sx={{ borderRadius: 20, fontWeight: "600",'@media (min-width: 1636px)': {
                  fontSize: '1.2rem'
                } }}
              >
                {" "}
                Login{" "}
              </Button>
            </Box>
            <LoginFooter></LoginFooter>
          </Box>
          <Confirmation
            visible={modalVisible}
            primaryText="Incorrect Passcode!"
            image="error"
            alert={true}
            toggleModal={(flag) => setModalVisible(flag)}
            timeout={5000}
          ></Confirmation>
        </Box>
      </Grid>
    </Grid>
  );
}

export default NewUserPasscodeValidate;
